'use client';
import React from 'react';
import { Box, Button, Flex, Link, Text } from '@skin-seoul/design-system';

interface LoyaltySignUpBannerMobileProps {
  titleLine2?: string;
}

export const LoyaltySignUpBannerMobile = ({ titleLine2 = 'SkinSociety' }: LoyaltySignUpBannerMobileProps) => {
  return (
    <Box
      position="relative"
      width="100%"
      height="112px"
      borderRadius="12px"
      bgGradient="to-tl"
      gradientFrom="#311275"
      gradientTo="#754DCC"
      overflow="hidden"
    >
      <Flex position="relative" height="100%" alignItems="center" justifyContent="space-between" px={4} zIndex={1}>
        {/* Left Side - Title */}
        <Flex direction="column" gap={0}>
          <Text color="primary.100" textStyle="heading.h6.mobile" fontWeight="bold">
            Join
          </Text>
          <Text color="primary.100" textStyle="heading.h6.mobile" fontWeight="bold">
            {titleLine2}
          </Text>
        </Flex>

        {/* Right Side - Sign Up Button */}
        <Button
          asChild
          size="sm"
          variant="primary"
          bg="white"
          color="neutral.800"
          _hover={{ bg: 'neutral.50' }}
          px={4}
          height="40px"
        >
          <Link unstyled href="/my-account/">
            Sign Up
          </Link>
        </Button>
      </Flex>
    </Box>
  );
};
